import { render, staticRenderFns } from "./inOut.vue?vue&type=template&id=210da3bc&scoped=true&"
import script from "./inOut.vue?vue&type=script&lang=js&"
export * from "./inOut.vue?vue&type=script&lang=js&"
import style0 from "./inOut.vue?vue&type=style&index=0&lang=css&"
import style1 from "./inOut.vue?vue&type=style&index=1&id=210da3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210da3bc",
  null
  
)

export default component.exports